import icon_account_settings from "./icon_account_settings.vue";
import icon_agents from "./icon_agents.vue";
import icon_agents_add from "./icon_agents_add.vue";
import icon_antivandalism from "./icon_antivandalism.vue"
import icon_attention from "./icon_attention.vue";
import icon_bag from "./icon_bag.vue";
import icon_car from "./icon_car.vue";
import icon_car_battery from "./icon_car_battery.vue";
import icon_car_battery_off from "./icon_car_battery_off.vue";
import icon_car_brakes from "./icon_car_brakes.vue";
import icon_car_engine from "./icon_car_engine.vue";
import icon_car_oil from "./icon_car_oil.vue";
import icon_car_speed from "./icon_car_speed.vue";
import icon_car_temp from "./icon_car_temp.vue";
import icon_cel_level_0 from "./icon_cel_level_0.vue";
import icon_cel_level_1 from "./icon_cel_level_1.vue";
import icon_cel_level_2 from "./icon_cel_level_2.vue";
import icon_cel_level_3 from "./icon_cel_level_3.vue";
import icon_cel_level_4 from "./icon_cel_level_4.vue";
import icon_certified from "./icon_certified.vue";
import icon_checkmark from "./icon_checkmark.vue";
import icon_close from "./icon_close.vue";
import icon_close_circle from "./icon_close_circle.vue";
import icon_crane from "./icon_crane.vue";
import icon_display_map from "./icon_display_map.vue";
import icon_display_both from "./icon_display_both.vue";
import icon_display_grid from "./icon_display_grid.vue";
import icon_document from "./icon_document.vue";
import icon_document_download from "./icon_document_download.vue";
import icon_edit_pen from "./icon_edit_pen.vue";
import icon_ellipses from "./icon_ellipses.vue";
import icon_envelope from "./icon_envelope.vue";
import icon_events from "./icon_events.vue";
import icon_fleet_management from "./icon_fleet_management.vue";
import icon_geofences from "./icon_geofences.vue";
import icon_geofence_add from "./icon_geofence_add.vue";
import icon_geofence_circle from "./icon_geofence_circle.vue";
import icon_geofence_polygon from "./icon_geofence_polygon.vue";
import icon_geofences_in from "./icon_geofences_in.vue";
import icon_geofences_out from "./icon_geofences_out.vue";
import icon_help_center from "./icon_help_center.vue";
import icon_temperature from "./icon_temperature.vue"
import icon_home from "./icon_home.vue";
import icon_link from "./icon_link.vue";
import icon_live_tracking from "./icon_live_tracking.vue";
import icon_location from "./icon_location.vue";
import icon_logout from "./icon_logout.vue";
import icon_maps from "./icon_maps.vue";
import icon_menu_opener from "./icon_menu_opener.vue";
import icon_motorcycle from "./icon_motorcycle.vue";
import icon_new_user from "./icon_new_user.vue";
import icon_notifications from "./icon_notifications.vue";
import icon_panic_button from "./icon_panic_button.vue";
import icon_passenger from "./icon_passenger.vue";
import icon_play from "./icon_play.vue";
import icon_reports from "./icon_reports.vue";
import icon_layers_map from "./icon_layers_map.vue";
import icon_s_logo from "./icon_s_logo.vue";
import icon_toggle from "./icon_toggle.vue";
import icon_ralenti from "./icon_ralenti.vue";
import icon_fuel_deviation from "./icon_fuel_deviation.vue";
import icon_dump_truck from "./icon_dump_truck.vue";
import icon_jamming from "./icon_jamming.vue";
import icon_trails from "./icon_trails.vue";
import icon_trailer from "./icon_trailer.vue";
import icon_truck from "./icon_truck.vue";
import icon_truck_loading_gate_open from "./icon_truck_loading_gate_open.vue"
import icon_unhook from "./icon_unhook.vue"
import icon_user from "./icon_user.vue";
import icon_user_settings from "./icon_user_settings.vue";
import icon_van from "./icon_van.vue";
import icon_fuel_cut_off_true from "./icon_fuel_cut_off_true.vue"
import icon_fuel_cut_off_false from "./icon_fuel_cut_off_false.vue"
import icon_stop_large_lapse from "./icon_stop_large_lapse.vue"

import icon_no_report from "./icon_no_report.vue";
import icon_ignition_on from "./icon_ignition_on.vue";
import icon_ignition_off from "./icon_ignition_off.vue";

import icon_car_clutch from './icon_car_clutch.vue'
import icon_car_cruise from './icon_car_cruise.vue'
import icon_car_brake_retarder from './icon_car_brake_retarder.vue'
import icon_car_speedometer from './icon_car_speedometer.vue'
import icon_car_horometro from './icon_car_horometro.vue'
import icon_car_pto from './icon_car_pto.vue'
import icon_car_retarder_torq from './icon_car_retarder_torq.vue'
import icon_car_gas_tank from './icon_car_gas_tank.vue'
import icon_car_torq_motor from './icon_car_torq_motor.vue'
import icon_car_odometer from './icon_car_odometer.vue'
import icon_car_water_tank from './icon_car_water_tank.vue'
import icon_unexpected_cargo_gate_opening from './icon_unexpected_cargo_gate_opening.vue'
import icon_unexpected_door_opening from './icon_unexpected_door_opening.vue'
import icon_unexpected_semi_detach from './icon_unexpected_semi_detach.vue'
import icon_saved_reports from './icon_saved_reports.vue'
import icon_create_report from './icon_create_report.vue'
import icon_road_machinery from './icon_road_machinery.vue'
import icon_tags from './icon_tags.vue'
import icon_switch_maps from "./icon_switch_maps.vue";
import icon_filter from "./icon_filter.vue"
import icon_filter_applied from "./icon_filter_applied.vue"
import icon_points_of_interest from "./icon_points_of_interest.vue"
import icon_option_settings from "./icon_option_settings.vue"
import icon_customers from "./icon_customers.vue"
import icon_deposits from "./icon_deposits.vue"
import icon_service_station from "./icon_service_station.vue"
import icon_authorized_stop from "./icon_authorized_stop.vue"
import icon_map_location_solid from "./icon_map_location_solid.vue"
import icon_inns from "./icon_inns.vue"
import icon_office_building from "./icon_office_building.vue"
import icon_industrial_park from "./icon_industrial_park.vue"
import icon_factory from "./icon_factory.vue"
import icon_transportation from "./icon_transportation.vue"
import icon_person_groups from "./icon_person_groups.vue"

// report app
import icon_reloj from "./icon_reloj.vue"

export default {
  icon_reloj,
  icon_filter_applied,
  icon_filter,
  icon_switch_maps,
  icon_tags,
  icon_saved_reports,
  icon_create_report,
  icon_unexpected_semi_detach,
  icon_unexpected_door_opening,
  icon_unexpected_cargo_gate_opening,
  icon_car_water_tank,
  icon_car_odometer,
  icon_car_torq_motor,
  icon_car_gas_tank,
  icon_car_pto,
  icon_car_retarder_torq,
  icon_car_horometro,
  icon_car_speedometer,
  icon_car_cruise,
  icon_car_brake_retarder,
  icon_no_report,
  icon_ignition_on,
  icon_ignition_off,
  icon_fuel_cut_off_true,
  icon_fuel_cut_off_false,
  icon_account_settings,
  icon_agents,
  icon_agents_add,
  icon_antivandalism,
  icon_ralenti,
  icon_temperature,
  icon_fuel_deviation,
  icon_dump_truck,
  icon_jamming,
  icon_attention,
  icon_bag,
  icon_car,
  icon_car_clutch,
  icon_car_battery,
  icon_car_battery_off,
  icon_car_brakes,
  icon_car_engine,
  icon_car_oil,
  icon_car_speed,
  icon_car_temp,
  icon_cel_level_0,
  icon_cel_level_1,
  icon_cel_level_2,
  icon_cel_level_3,
  icon_cel_level_4,
  icon_certified,
  icon_checkmark,
  icon_close,
  icon_close_circle,
  icon_crane,
  icon_document,
  icon_document_download,
  icon_display_both,
  icon_display_grid,
  icon_display_map,
  icon_edit_pen,
  icon_ellipses,
  icon_envelope,
  icon_events,
  icon_fleet_management,
  icon_geofences,
  icon_geofence_add, 
  icon_geofence_circle, 
  icon_geofence_polygon,
  icon_geofences_in,
  icon_geofences_out,
  icon_help_center,
  icon_home,
  icon_link,
  icon_live_tracking,
  icon_location,
  icon_logout,
  icon_maps,
  icon_menu_opener,
  icon_motorcycle,
  icon_new_user,
  icon_notifications,
  icon_panic_button,
  icon_passenger,
  icon_play,
  icon_reports,
  icon_layers_map,
  icon_s_logo,
  icon_toggle,
  icon_trails,
  icon_trailer,
  icon_truck,
  icon_truck_loading_gate_open,
  icon_unhook,
  icon_user,
  icon_user_settings,
  icon_van,
  icon_stop_large_lapse,
  icon_road_machinery,
  icon_points_of_interest,
  icon_option_settings,
  icon_customers,
  icon_deposits,
  icon_service_station,
  icon_authorized_stop,
  icon_map_location_solid,
  icon_inns,
  icon_office_building,
  icon_industrial_park,
  icon_factory,
  icon_transportation,
  icon_person_groups
};
